const { REACT_APP_ADMIN_CREDENTIALS, REACT_APP_TEST_USER_CREDENTIALS } = process.env;

export const REACT_APP_LIFERAY_HOST =
process.env.NODE_ENV === "development"
? process.env.REACT_APP_LIFERAY_HOST // Backend URL from .env in dev
: window.location.origin; // Same domain in production

console.log("🚀 ~ REACT_APP_LIFERAY_HOST:", REACT_APP_LIFERAY_HOST)
const headers = window.Liferay
  ? {
      "Content-Type": "application/json",
      "x-csrf-token": window.Liferay.authToken,
    }
  : {
      "Content-Type": "application/json",
      Authorization: "Basic " + btoa(String(REACT_APP_TEST_USER_CREDENTIALS).trim()),
    };

const LiferayService = {
  get: (url, options = {}) => {
    return new Promise(async (resolve, reject) => {
      console.log("🚀 ~ get ~ headers:", headers)
      try {
        const response = await fetch(REACT_APP_LIFERAY_HOST + "/" + url, {
          headers,
          method: "GET",
          ...options,
        });
        const data = await response.json();
        console.log({ data });
        if (response.ok) {
          resolve(data);
        } else {
          window.Liferay?.Util.openToast({
            title: data.status,
            message: "An error occured.",
            type: "danger",
          });
          reject(false);
        }
      } catch (error) {
        window.Liferay?.Util.openToast({
          message: "An error occured.",
          type: "danger",
        });
        reject(error);
      }
    });
  },
  post: (url, payload, options = {}) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await fetch(REACT_APP_LIFERAY_HOST + "/" + url, {
          headers,
          method: "POST",
          body: JSON.stringify(payload),
          ...options,
        });
        const data = await response.json();
        if (response.ok) {
          if (window.Liferay) {
            window.Liferay?.Util.openToast({
              message: "Your request has been completed.",
              type: "success",
            });
          }
          resolve(data);
        } else {
          window.Liferay?.Util.openToast({
            title: data.status,
            message: "An error occured.",
            type: "danger",
          });
          reject(false);
        }
      } catch (error) {
        window.Liferay?.Util.openToast({
          message: "An error occured.",
          type: "danger",
        });
        reject(error);
      }
    });
  },
  put: (url, payload, options = {}) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await fetch(REACT_APP_LIFERAY_HOST + "/" + url, {
          headers,
          method: "PUT",
          body: JSON.stringify(payload),
          ...options,
        });
        const data = await response.json();
        if (response.ok) {
          if (window.Liferay) {
            window.Liferay?.Util.openToast({
              message: "Your request has been completed.",
              type: "success",
            });
          }
          resolve(data);
        } else {
          window.Liferay?.Util.openToast({
            title: data.status,
            message: "An error occured.",
            type: "danger",
          });
          reject(false);
        }
      } catch (error) {
        window.Liferay?.Util.openToast({
          message: "An error occured.",
          type: "danger",
        });
        reject(error);
      }
    });
  },
  patch: (url, payload, options = {}) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await fetch(REACT_APP_LIFERAY_HOST + "/" + url, {
          headers,
          method: "PATCH",
          body: JSON.stringify(payload),
          ...options,
        });
        const data = await response.json();
        if (response.ok) {
          if (window.Liferay) {
            window.Liferay?.Util.openToast({
              message: "Your request has been completed.",
              type: "success",
            });
          }
          resolve(data);
        } else {
          window.Liferay?.Util.openToast({
            title: data.status,
            message: "An error occured.",
            type: "danger",
          });
          reject(false);
        }
      } catch (error) {
        window.Liferay?.Util.openToast({
          message: "An error occured.",
          type: "danger",
        });
        reject(error);
      }
    });
  },
  delete: (url) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await fetch(REACT_APP_LIFERAY_HOST + "/" + url, {
          headers,
          method: "DELETE",
        });

        if (response.ok) {
          console.log("Response ok");
          if (window.Liferay) {
            window.Liferay?.Util.openToast({
              message: "Your request has been completed.",
              type: "success",
            });
          }
          resolve(true);
        } else {
          console.log("Response NOT ok");

          window.Liferay?.Util.openToast({
            message: "An error occured.",
            type: "danger",
          });
          reject(false);
        }
      } catch (error) {
        console.log("🚀 ~ returnnewPromise ~ error:", error);
        window.Liferay?.Util.openToast({
          message: "An error occured.",
          type: "danger",
        });
        reject(error);
      }
    });
  },

  getAdmin: (url, options = {}) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await fetch(REACT_APP_LIFERAY_HOST + "/" + url, {
           headers:{
                Authorization: "Basic " + btoa(String(REACT_APP_ADMIN_CREDENTIALS).trim()),
                Accept: "application/json",
            },
          method: "GET",
          ...options,
        });
        const data = await response.json();
        if (response.ok) {
          resolve(data);
        } else {
          reject(false);
        }
      } catch (error) {
        reject(error);
      }
    });
  },
};

export default LiferayService;
